import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/Users.module.css";
import { API } from "../config";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(API.USER, { cache: "no-store" })
      .then((res) => res.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      const res = await fetch(`${API.USER}/${id}`, { method: "DELETE" });
      if (!res.ok) return alert("Failed to delete user");

      setUsers(users.filter((user) => user.id !== id));
    } catch {
      alert("Server error");
    }
  };

  return (
    <div className={styles.usersPage}>
      <div className={styles.usersCard}>
        <h2 className={styles.usersTitle}>👥 Users</h2>

        <div className={styles.tableHeader}>
  {/* LEFT BUTTON */}
  <button
    className={styles.dashboardBtn}
    onClick={() => navigate(-1)}
  >
    ⬅ Dashboard
  </button>

  {/* RIGHT BUTTON */}
  <button
    className={styles.navigateBtn}
    onClick={() => navigate("/api-testing")}
  >
    
    + Add user
  </button>
</div>

        

        {loading ? (
          <div className={styles.loader}>Loading users...</div>
        ) : (
          <table className={styles.usersTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile Number</th>
                <th>Password</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.number}</td>
                  <td>{user.password}</td>
                  <td>
                    <button
                      className={styles.deleteBtn}
                      onClick={() => handleDelete(user.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Users;
